import Vue from 'vue'
import VueRouter from "vue-router";
import store from "./store/store"

import Dashboard from "./components/Dashboard"
import Student from "./components/Student"
import Company from "./components/Company"
import Process from "./components/Process"
import Log from "./components/Log"
import ProcessNew from "./components/process/ProcessNew"
import StudentNew from "./components/student/StudentNew"
import Home from "./components/Home"
import Login from "./components/Login"
import StudentInfo from "./components/student/StudentInfo"
import CompanyNew from "./components/company/CompanyNew"
import CompanyInfo from "./components/company/CompanyInfo"
import CompanyEdit from "./components/company/CompanyEdit"


Vue.use(VueRouter);
export const router = new VueRouter({
    routes : [
        { path : "", component : Login,
    
    },
    { path : "/login", component : Login,
    
    },
    
        { path : '/vue' , component : Home, children : [
            { 
                path : '/home', 
                component : Dashboard, 
                beforeEnter(to, from, next){
                    if(store.getters.isAuthenticated == true){
                        console.log(store.getters.isAuthenticated)
                        next()
                    }else{
                        next("/login")
                        console.log("giriş yapılmamış " )
                    }                   
                }
          },
            { path : '/student' , 
            component : Student,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
         },
            { path : '/company' , 
            component : Company,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
            { path : '/process' , 
            component : Process,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
            { path : '/log' , 
            component : Log,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
            { path : '/processnew' , 
            component : ProcessNew,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
            { path : '/studentnew' , 
            component : StudentNew,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
        { path : '/studentinfo' , 
            component : StudentInfo,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
        { path : '/companynew' , 
            component : CompanyNew,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
        { path : '/companyinfo' , 
            component : CompanyInfo,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },
        { path : '/companyedit' , 
            component : CompanyEdit,
            beforeEnter(to, from, next){
                if(store.getters.isAuthenticated == true){
                    console.log(store.getters.isAuthenticated)
                    next()
                }else{
                    next("/login")
                    console.log("giriş yapılmamış " )
                }                   
            }
        },


        ]  },
    ],
  mode:'hash',
});






// WEBPACK FOOTER //
// ./src/routes.js